import React from 'react';
import LatestCoinsMinted from './LatestCoinsMinted';
import LatestTransactions from './LatestTransactions';
import RichestAccounts from './RichestAccounts';
import LatestCoinsBought from './LatestCoinsBought';

export default class AnalyticsPage extends React.Component {
  render () {
    return (
      <div className="c-analytics-page">
        <h1>Analytics</h1>
        <div className="c-components">
          <LatestTransactions/>
          <LatestCoinsMinted/>
          <LatestCoinsBought/>
          <RichestAccounts/>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/AnalyticsPage/AnalyticsPage.js